import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { Box, Chip, Divider, Stack, Typography } from "@mui/material";
import type { SpofCard } from "../types";
import DashboardCard from "./DashboardCard";
import { PendingValue } from "./PendingValue";

/** Where the SPOF sits in the plant, from the register columns that are filled in. */
function assetPath(spof: SpofCard): string {
  return [
    spof.power_plant_name,
    spof.phase,
    spof.unit ?? spof.block,
    spof.system,
    spof.functional_location,
  ]
    .filter(Boolean)
    .join(" > ");
}

export default function SpofFailureCard({ spof }: { spof: SpofCard }) {
  const tags = [
    spof.spof_category,
    spof.failure_history_referenced &&
      `Failure history: ${spof.failure_history_referenced}`,
  ].filter(Boolean) as string[];

  return (
    <DashboardCard title="Failure Scenario & Consequence">
      <Typography variant="body2">
        {spof.failure_description_long ?? spof.failure_description_short ?? (
          <PendingValue />
        )}
      </Typography>

      {tags.length > 0 && (
        <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap" }}>
          {tags.map((tag) => (
            <Chip key={tag} size="small" label={tag} variant="outlined" />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <AccountTreeIcon fontSize="small" sx={{ color: "text.secondary" }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Asset mapping
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {assetPath(spof) || <PendingValue />}
          </Typography>
        </Box>
      </Box>
    </DashboardCard>
  );
}
